module.exports = __webpack_public_path__ + "img/My-Vote.c5394850.png";